import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-con6',
  templateUrl: './e-con6.component.html',
  styleUrls: ['./e-con6.component.css']
})
export class ECon6Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
